import { Record } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { UserSession_$reflection } from "./Shared/ApiDataTypes.js";
import { record_type, bool_type, lambda_type, unit_type, class_type, obj_type, option_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Localization_Language, Localization_Language_$reflection } from "./Shared/Shared.js";
import no_nb from "../locale/no-nb.json";
import node_polyglot from "node-polyglot";
import { nb } from "date-fns/locale";
import { some } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import * as react from "react";

export class GlobalCtx extends Record {
    constructor(Session, Language, Locale, DateFnsLocale, SetLanguage, SidebarOpen, SetSidebarOpen, HideSidebar, SetHideSidebar) {
        super();
        this.Session = Session;
        this.Language = Language;
        this.Locale = Locale;
        this.DateFnsLocale = DateFnsLocale;
        this.SetLanguage = SetLanguage;
        this.SidebarOpen = SidebarOpen;
        this.SetSidebarOpen = SetSidebarOpen;
        this.HideSidebar = HideSidebar;
        this.SetHideSidebar = SetHideSidebar;
    }
}

export function GlobalCtx_$reflection() {
    return record_type("GlobalContext.GlobalCtx", [], GlobalCtx, () => [["Session", option_type(UserSession_$reflection())], ["Language", Localization_Language_$reflection()], ["Locale", obj_type], ["DateFnsLocale", class_type("Locale.DateFns.ILocale")], ["SetLanguage", lambda_type(Localization_Language_$reflection(), unit_type)], ["SidebarOpen", bool_type], ["SetSidebarOpen", lambda_type(bool_type, unit_type)], ["HideSidebar", bool_type], ["SetHideSidebar", lambda_type(bool_type, unit_type)]]);
}

export function GlobalCtx_New_11EF06A4(session) {
    let phrases;
    return new GlobalCtx(session, new Localization_Language(0, []), (phrases = no_nb, new node_polyglot({ phrases: phrases, locale: "no" })), nb, (value) => {
    }, false, (_arg) => {
        console.error(some("[GlobalCtx] Called SetSidebarOpen uninitialized!"));
    }, false, (_arg_1) => {
        console.error(some("[GlobalCtx] Called SetHideSidebar uninitialized!"));
    });
}

export const ctx = (() => {
    const defaultValue = GlobalCtx_New_11EF06A4(undefined);
    return react.createContext(defaultValue);
})();

